import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import Page from '@Containers/Page';
import InProductMessages from '@Containers/InProductMessages';
import PropTypes from 'prop-types';
import { initializeQuickSearch } from './QuickSearchActions';
import BuildQuery from './Components/BuildQuery/BuildQueryContainer';
import QuickResults from './Components/QuickResults/QuickResultsContainer';
import SimpleSpinner from '../../Components/Results/utils/SimpleSpinner';
import { QUICK_SEARCH_ROUTE, QUICK_SEARCH_ROUTES } from './routes';
import { withCombinedRouteParams } from '../../AppRoutes/ConnectedRoute';

const spinnerId = 'quick-search-spinner';

function QuickSearch({ action, searchId }) {
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    initializeQuickSearch(action).then(() => {
      setInitialized(true);
    });
    // eslint-disable-next-line
  }, [action]);
  return (
    <Page headerType="main" withFooter pageClassName="quick-search-page" className="react-page-static__wrapper">
      <main className="page-container page-container--hexagons quick-search" aria-label="Quick Search">
        <InProductMessages />
        {initialized ? (
          <Switch>
            <Route path={QUICK_SEARCH_ROUTE} exact render={() => <SimpleSpinner id={spinnerId} />} />
            <Route path={QUICK_SEARCH_ROUTES.QUERY} render={() => <BuildQuery />} />
            <Route path={QUICK_SEARCH_ROUTES.RESULTS} render={() => <QuickResults key={searchId} searchId={searchId} />} />
          </Switch>
        ) : (
          <SimpleSpinner id={spinnerId} />
        )}
      </main>
    </Page>
  );
}

QuickSearch.propTypes = {
  action: PropTypes.string,
  searchId: PropTypes.string,
};

export default withCombinedRouteParams(QuickSearch);
